var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcDetergent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_50",
  "data-name": "Path 50",
  d: "M0-24H48V24H0Z",
  transform: "translate(0 24)",
  fill: "none",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52",
  "data-name": "Path 52",
  d: "M6-22H34.006a2,2,0,0,1,2,2V16a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V-20A2,2,0,0,1,6-22Z",
  transform: "translate(-4 22)",
  fill: "none",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-3"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_56",
  "data-name": "Path 56",
  d: "M7-12v2H27v-2Z",
  transform: "translate(-7 12)",
  fill: "#4bbeff",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-5"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_58",
  "data-name": "Path 58",
  d: "M7-15v2h8v-2Z",
  transform: "translate(-7 15)",
  fill: "#4bbeff",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-7"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_64",
  "data-name": "Path 64",
  d: "M18.309-11.567a1.008,1.008,0,0,0-.416-.816,4.043,4.043,0,0,0-1.4-.6,4.843,4.843,0,0,1-2-.892,1.776,1.776,0,0,1-.628-1.4,1.818,1.818,0,0,1,.616-1.416,2.88,2.88,0,0,1,1.692-.658V-18.5h.96v1.158a2.676,2.676,0,0,1,1.686.742,2.338,2.338,0,0,1,.6,1.7H18.231a1.6,1.6,0,0,0-.432-1.179,1.566,1.566,0,0,0-1.167-.437,1.846,1.846,0,0,0-1.173.324,1.09,1.09,0,0,0-.406.9,1.012,1.012,0,0,0,.429.855,4.33,4.33,0,0,0,1.412.579,6.619,6.619,0,0,1,1.534.574,2.229,2.229,0,0,1,.812.729,1.793,1.793,0,0,1,.261.974,1.768,1.768,0,0,1-.654,1.432,3.244,3.244,0,0,1-1.834.642V-8.5h-.954V-9.5a3.079,3.079,0,0,1-1.879-.7,2.1,2.1,0,0,1-.68-1.65h1.192a1.388,1.388,0,0,0,.471,1.127,2.02,2.02,0,0,0,1.334.395,2.319,2.319,0,0,0,1.328-.332A1.042,1.042,0,0,0,18.309-11.567Z",
  transform: "translate(-13.5 18.5)",
  fill: "none",
  clipRule: "evenodd"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_detergent",
  transform: "translate(0 24)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_92",
  "data-name": "Group 92",
  transform: "translate(0 -24)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_49",
  "data-name": "Path 49",
  d: "M-5-29H63V39H-5Z",
  transform: "translate(-5 19)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_94",
  "data-name": "Group 94",
  transform: "translate(7.997 -19.999)",
  clipPath: "url(#clip-path-2)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_93",
  "data-name": "Group 93"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_51",
  "data-name": "Path 51",
  d: "M2,0H30.006a2,2,0,0,1,2,2V38a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z",
  fill: "none",
  stroke: "#4bbeff",
  strokeWidth: 2
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_96",
  "data-name": "Group 96",
  transform: "translate(13.998 10)",
  clipPath: "url(#clip-path-3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_55",
  "data-name": "Path 55",
  d: "M2-17H42.007V5H2Z",
  transform: "translate(-12.002 6.998)",
  fill: "#4bbeff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1259",
  "data-name": "Group 1259",
  transform: "translate(13.998 14.999)",
  clipPath: "url(#clip-path-3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_437",
  "data-name": "Path 437",
  d: "M2-17H42.007V5H2Z",
  transform: "translate(-12.002 6.998)",
  fill: "#4bbeff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_97",
  "data-name": "Group 97",
  transform: "translate(13.999 5)",
  clipPath: "url(#clip-path-5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_57",
  "data-name": "Path 57",
  d: "M2-20H30.005V2H2Z",
  transform: "translate(-12.002 9.998)",
  fill: "#4bbeff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1269",
  "data-name": "Group 1269",
  transform: "translate(13.999 0.001)",
  clipPath: "url(#clip-path-5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_443",
  "data-name": "Path 443",
  d: "M2-20H30.005V2H2Z",
  transform: "translate(-12.002 9.998)",
  fill: "#4bbeff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_100",
  "data-name": "Group 100",
  transform: "translate(26.999 -2.001)",
  clipPath: "url(#clip-path-7)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_63",
  "data-name": "Path 63",
  d: "M8.5-23.5h26V6.506H8.5Z",
  transform: "translate(-18.502 13.498)",
  fill: "#4bbeff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_101",
  "data-name": "Group 101",
  transform: "translate(26.999 -2.001)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_65",
  "data-name": "Path 65",
  d: "M4.809,6.933a1.008,1.008,0,0,0-.416-.816,4.042,4.042,0,0,0-1.4-.6,4.844,4.844,0,0,1-2-.892,1.776,1.776,0,0,1-.628-1.4A1.818,1.818,0,0,1,.977,1.811a2.88,2.88,0,0,1,1.692-.658V0h.96V1.158A2.676,2.676,0,0,1,5.315,1.9a2.338,2.338,0,0,1,.6,1.7H4.731A1.6,1.6,0,0,0,4.3,2.422a1.566,1.566,0,0,0-1.167-.437,1.846,1.846,0,0,0-1.173.324,1.09,1.09,0,0,0-.406.9,1.012,1.012,0,0,0,.429.855,4.331,4.331,0,0,0,1.412.579,6.62,6.62,0,0,1,1.534.574,2.229,2.229,0,0,1,.812.729A1.793,1.793,0,0,1,6,6.922a1.768,1.768,0,0,1-.654,1.432A3.243,3.243,0,0,1,3.513,9V10H2.559V9A3.079,3.079,0,0,1,.68,8.3,2.1,2.1,0,0,1,0,6.649H1.192a1.388,1.388,0,0,0,.471,1.127A2.02,2.02,0,0,0,3,8.17a2.319,2.319,0,0,0,1.328-.332A1.042,1.042,0,0,0,4.809,6.933Z",
  fill: "none",
  stroke: "#4bbeff",
  strokeWidth: 0.3
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1267",
  "data-name": "Group 1267",
  transform: "translate(-8 -20)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1264",
  "data-name": "Group 1264",
  transform: "translate(-2970 -14042)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_966",
  "data-name": "Rectangle 966",
  transform: "translate(2992 14049)",
  fill: "#fff",
  stroke: "#4bbeff",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M5,0H7a5,5,0,0,1,5,5v5a1,1,0,0,1-1,1H2A2,2,0,0,1,0,9V5A5,5,0,0,1,5,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5,1H7a4,4,0,0,1,4,4v5a0,0,0,0,1,0,0H2A1,1,0,0,1,1,9V5A4,4,0,0,1,5,1Z",
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_967",
  "data-name": "Rectangle 967",
  transform: "translate(2996 14045)",
  fill: "#fff",
  stroke: "#4bbeff",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M1,0H3A1,1,0,0,1,4,1V5A0,0,0,0,1,4,5H0A0,0,0,0,1,0,5V1A1,1,0,0,1,1,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1,1H3A0,0,0,0,1,3,1V3A1,1,0,0,1,2,4H2A1,1,0,0,1,1,3V1A0,0,0,0,1,1,1Z",
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_968",
  "data-name": "Rectangle 968",
  transform: "translate(2997 14052)",
  fill: "#fff",
  stroke: "#4bbeff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0H1A3,3,0,0,1,4,3V4A0,0,0,0,1,4,4H0A0,0,0,0,1,0,4V0A0,0,0,0,1,0,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1,.5H1A2.5,2.5,0,0,1,3.5,3V3a.5.5,0,0,1-.5.5H1A.5.5,0,0,1,.5,3V1A.5.5,0,0,1,1,.5Z",
  fill: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_107",
  "data-name": "Ellipse 107",
  transform: "translate(35 6)",
  fill: "none",
  stroke: "#4bbeff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 1.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_108",
  "data-name": "Ellipse 108",
  transform: "translate(39 3)",
  fill: "none",
  stroke: "#4bbeff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.5,
  cy: 1.5,
  r: 1,
  fill: "none"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcDetergent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_detergent.c4ca379efdcb1d682ed5ce30d8ac1126.svg";